import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/kits/reglas',documento:'catalogs',acceso:'sesion',filas:['063'],cita:'Areas/Catalogs/Controllers/KitRulesController.cs:70'} satisfies RutaProd;
